import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { RouteFallback } from '@/components/ui/RouteFallback'

// The tab bar that used to sit here (Notificações · Remetentes · Revisões · Minhas Correções) is
// gone (Diogo, 2026-09-21). Two rows of navigation above one list was one too many: the page
// already carries its own filter chips, and a reader landing from the bell had to parse a tab bar
// before reaching them.
//
// Remetentes moved INTO those chips — it is a queue you read, so it belongs beside the other
// things you read, not behind a tab. See Notificacoes.tsx.
//
// The ROUTES are untouched. /operacoes/notificacoes/{remetentes,revisoes,minhas-correcoes} still
// render, still carry their RequireRole guards, and the legacy /operacoes/{revisoes,
// minhas-correcoes} redirects keep working. What changed is what the UI OFFERS; nothing became
// unreachable by URL. Revisões and Minhas Correções now have no entry point in the UI — that was
// the instruction, and it is flagged rather than hidden.
//
// This layout is now a thin wrapper, kept rather than dissolved so the child routes keep a single
// Suspense boundary instead of growing one each.
export function NotificacoesLayout() {
  return (
    <div className="flex flex-col gap-5">
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
    </div>
  )
}
